export default {
  getConfiguration : (state) => { return state.configuration; },
}
